module.exports = __webpack_public_path__ + "static/media/Inter-Medium.8c46da0d.otf";